/**
 * Cloudflare Turnstile configuration (SPR-009, CON-002 §5A).
 *
 * The site key is a PUBLIC, client-safe value read from CRA env config
 * (`REACT_APP_*`) — it is NOT a secret. The secret key lives server-side only
 * (`Turnstile:SecretKey`) and is used by the API to verify the token via the
 * siteverify API before the BookingService sends the email.
 *
 * In dev/tests we fall back to Cloudflare's documented TEST site key
 * (`1x00000000000000000000AA`), which always passes — so the real key can drop
 * in later via env without code changes.
 */

/** Cloudflare's "always passes" test site key (dev/test default). */
export const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000AA";

/** Cloudflare's Turnstile widget script. */
export const TURNSTILE_SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

/**
 * @returns {string} Public Turnstile site key. Falls back to the test key
 * (always passes) when `REACT_APP_TURNSTILE_SITE_KEY` is unset.
 */
export const turnstileSiteKey = () =>
  process.env.REACT_APP_TURNSTILE_SITE_KEY || TURNSTILE_TEST_SITE_KEY;
